import React from 'react';
import UnifiedState from './UnifiedState';
import './RouteFallback.css';

const RouteLoadingState = ({ title = 'Opening workspace…' }) => (
  <div className="route-fallback-page" aria-busy="true">
    <div className="route-fallback-card">
      <UnifiedState type="loading" title={title} rows={4} />
    </div>
  </div>
);

export default RouteLoadingState;
